import React from 'react'
import BackButton from '../UI/BackButton'
import PageTitle from '../UI/PageTitle'

const ServiceNotFound = () => (
  <section>
    <header>
      <PageTitle>
        Service not found!
      </PageTitle>
    </header>
    <br/>
    <BackButton/>
  </section>
)

export default ServiceNotFound



// WEBPACK FOOTER //
// ./src/components/Services/ServiceNotFound.jsx